var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topNavigation',{staticStyle:{"display":"none"},attrs:{"deleteSort":[4],"addEndRightMenuList":[
			{ name: '产品介绍', toLink: '' },
			{ name: '视频介绍', toLink: '' } ]},scopedSlots:_vm._u([{key:"nav-top-content-isMobile-bottom",fn:function(){return [_c('homeNavIsMoblie',{staticStyle:{"width":"310px"}})]},proxy:true}])}),_c('appMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }